"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Assessments() {
  const headlineWords = [{
    text: "Where",
    italic: false
  }, {
    text: "water",
    italic: false
  }, {
    text: "meets",
    italic: false
  }, {
    text: "precision.",
    italic: true
  }];
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const {
    ref: introRef,
    isVisible: introVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const {
    ref: image1Ref,
    isVisible: image1Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: image2Ref,
    isVisible: image2Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="2777" id="assessmentshero" className="bg-background text-foreground relative min-h-[85vh] w-full overflow-hidden py-20 md:py-28 lg:py-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 lg:px-16">
        {}
        <div ref={labelRef} className={`mb-12 md:mb-20 transition-all duration-700 ease-out ${labelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-mono text-xs md:text-sm uppercase tracking-[0.18em]" style={{
          color: "var(--chart-5)"
        }}>
            § expertise — pool engineering
          </span>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 relative">
          {}
          <div aria-hidden="true" className="hidden lg:block absolute top-0 bottom-0 left-[58.33%] w-px" style={{
          background: "var(--border)"
        }} />

          {}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <h1 ref={headlineRef} className="font-serif font-light leading-[0.92] tracking-tight text-foreground" style={{
            fontSize: "clamp(56px, 12vw, 176px)"
          }}>
              {headlineWords.map((word, i) => <span key={i} data-index={i} className="inline-block overflow-hidden align-bottom mr-[0.18em]" style={{
              paddingBottom: "0.08em"
            }}>
                  <span className={`inline-block transition-all ease-out ${word.italic ? "italic" : ""} ${headlineVisible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`} style={{
                transitionDuration: "700ms",
                transitionDelay: `${i * 80}ms`,
                color: word.italic ? "var(--chart-1)" : "inherit"
              }}>
                    {word.text}
                  </span>
                </span>)}
            </h1>

            <p ref={introRef} className={`font-serif italic mt-10 md:mt-14 max-w-[36ch] text-base md:text-lg leading-relaxed transition-all duration-1000 delay-300 ease-out ${introVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            color: "var(--chart-4)"
          }}>
              Mastering the flow, structure, and clarity of your custom aquatic space.
            </p>
          </div>

          {}
          <div className="lg:col-span-5 flex flex-col justify-center gap-8 lg:gap-10 lg:pl-6">
            {}
            <figure ref={image1Ref} className={`transition-all duration-1000 ease-out ${image1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <div className="overflow-hidden rounded-3xl bg-card">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1752522/img/pool_installation_site.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1752522/img/pool_installation_site.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1752522/img/pool_installation_site.png-wvc-sizes" alt="Professional pool installation site preparation" loading="lazy" decoding="async" className="w-full h-auto object-cover aspect-[4/5]" />
              </div>
              <figcaption className="mt-3 font-mono text-[11px] md:text-xs uppercase tracking-[0.16em]" style={{
              color: "var(--chart-5)"
            }}>
                phase i. / site prep
              </figcaption>
            </figure>

            {}
            <figure ref={image2Ref} className={`ml-auto w-[72%] transition-all duration-1000 delay-200 ease-out ${image2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <div className="overflow-hidden rounded-3xl bg-card">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1752522/img/pool_water_clarity.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1752522/img/pool_water_clarity.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1752522/img/pool_water_clarity.png-wvc-sizes" alt="Crystal clear water in a finished pool" loading="lazy" decoding="async" className="w-full h-auto object-cover aspect-square" />
              </div>
              <figcaption className="mt-3 font-mono text-[11px] md:text-xs uppercase tracking-[0.16em]" style={{
              color: "var(--chart-5)"
            }}>
                phase ii. / final clarity
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>;
}